import { Component, OnInit } from '@angular/core'
import { AgentAuthService } from '../../../services/agent-auth.service'

@Component({
  imports: [],
  selector: 'app-agent-logged-out',
  templateUrl: './agent-logged-out.component.html',
  styleUrls: ['./agent-logged-out.component.scss']
})
export class AgentLoggedOutComponent implements OnInit {
  constructor (private agentAuthService: AgentAuthService) {}

  ngOnInit (): void {
    this.agentAuthService.signOut()
  }
}
